<h5 *ngIf="heading" class="mb-3 text-center">{{ heading }}</h5>
<dl class="{{ listClass }}" role="list">
  <ng-container *ngFor="let item of listItems; last as isLast">
    <div class="d-flex">
      <dt role="presentation"><om-svg-checkmark color="#004D49" width="16" height="13"></om-svg-checkmark></dt>
      <dd [ngClass]="{ 'mb-3': !isLast }" role="listitem">{{ item }}</dd>
    </div>
  </ng-container>
</dl>
